const TABS = [
  {
    id: 'domicilis',
    label: 'Domicilis',
    icon: (actiu) => (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" strokeWidth={actiu ? 2.5 : 1.8} strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 9.5L12 3l9 6.5V20a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9.5z" />
        <polyline points="9 21 9 12 15 12 15 21" />
      </svg>
    ),
  },
  {
    id: 'rutes',
    label: 'Rutes',
    icon: (actiu) => (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" strokeWidth={actiu ? 2.5 : 1.8} strokeLinecap="round" strokeLinejoin="round">
        <circle cx="5" cy="6" r="2" />
        <circle cx="19" cy="18" r="2" />
        <path d="M5 8c0 4 4 6 8 6s8 2 8 6" />
      </svg>
    ),
  },
  {
    id: 'config',
    label: 'Config',
    icon: (actiu) => (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" strokeWidth={actiu ? 2.5 : 1.8} strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="3" />
        <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06
          a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09
          A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83
          l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09
          A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83
          l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09
          a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83
          l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09
          a1.65 1.65 0 0 0-1.51 1z" />
      </svg>
    ),
  },
]

export default function Navigation({ activeTab, onTabChange }) {
  return (
    <nav style={S.nav}>
      {TABS.map(tab => {
        const actiu = activeTab === tab.id
        return (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            style={S.btn}
            aria-label={tab.label}
            aria-current={actiu ? 'page' : undefined}
          >
            <span style={{ ...S.icon, color: actiu ? '#007AFF' : '#9ca3af' }}>
              {tab.icon(actiu)}
            </span>
            <span style={{ ...S.label, color: actiu ? '#007AFF' : '#9ca3af', fontWeight: actiu ? 600 : 400 }}>
              {tab.label}
            </span>
          </button>
        )
      })}
    </nav>
  )
}

const S = {
  nav: {
    position: 'fixed', bottom: 0, left: 0, right: 0,
    height: 60,
    backgroundColor: '#fff',
    borderTop: '1px solid #e5e7eb',
    display: 'flex',
    alignItems: 'stretch',
    zIndex: 1000,
    paddingBottom: 'env(safe-area-inset-bottom)',
  },
  btn: {
    flex: 1,
    display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
    gap: 2,
    background: 'none', border: 'none', cursor: 'pointer', padding: '6px 0',
    WebkitTapHighlightColor: 'transparent',
  },
  icon:  { display: 'flex', alignItems: 'center', justifyContent: 'center' },
  label: { fontSize: 10, letterSpacing: '0.02em' },
}
